export const VectorFieldScores = {
    PREMIUM: 100,
    COMMON_REVEAL_CAVERN: 5,
    COMMON_HIDDEN_NEIGHBOR: 3,
    WORTHLESS: 0,
    IN_RANGE_OPEN: -10, // tile is in range but open
    IN_RANGE_UNSEEN: -20, // tile is in range but never seen.
    UNSET: -1000,
}